import '.j{display:flex;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.e1{background:var(--shades-white);}.ssr-plugin'
import '.c7{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.au{max-width:77.5rem;}.ssr-plugin'
import '.di{justify-content:stretch;}.ssr-plugin'
import '.bq{position:sticky;}.ssr-plugin'
import '.bv{top:0px;}.ssr-plugin'
import '.dj{z-index:10;}.ssr-plugin'
import '.f5{padding-block:1rem;}.ssr-plugin'
import '.f6{height:3rem;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.cw{flex-wrap:wrap;}.ssr-plugin'
import '.f7{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b9{margin-top:2rem;}.ssr-plugin'
import '.gr{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="j ae k v e1"
      >
        <div className="c7 j r k v"
        >
          <div className="au j v di bq bv dj"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="f5 f6 j a1 r cw"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="f7 j v ae b9 gr au"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
